import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-progress-indicator',
  templateUrl: './progress-indicator.component.html',
  styleUrl: './progress-indicator.component.css'
})
export class ProgressIndicatorComponent {

  refresh() {
    this.processing = true;
    this.clicked?.emit(this);
  }

  @Input()
  get processing(): boolean {
    return this._processing;
  }
  set processing(value: boolean) {
    this._processing = value;
  }
  private _processing: boolean = false;

  updateProcessing(value: boolean) {
    this.processing = value;
  }

  @Output()
  clicked: EventEmitter<ProgressIndicatorComponent> = new EventEmitter<ProgressIndicatorComponent>();

}
